import * as actionTypes from '../constants/actionTypes';
import * as def from '../constants/defines';

const initialState = {
    activeFrame: def.CHANNEL_FRAME
};

export function appContent(state = initialState, action) {
    switch (action.type) {
        case actionTypes.SHOW_CHANNEL_FRAME:
            return {
                ...state,
                activeFrame: def.CHANNEL_FRAME
            };

        case actionTypes.SHOW_PLAYER_FRAME:
            return {
                ...state,
                activeFrame: def.PLAYER_FRAME
            };

        case actionTypes.SHOW_USERDATA_FRAME:
            return {
                ...state,
                activeFrame: def.USERDATA_FRAME
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/appContent.js